<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <!-- <p>场所类型：</p> -->
          <el-row>
            <!-- <el-button type="info" :class="{active:search_data.type==''?true:false}" plain @click="placetype('')" v-model="search_data.type">全部</el-button> -->
            <!-- <el-button type="info" :class="{active:search_data.place_type==item.id?true:false}" plain v-for="item in place_type_list" :key="item.id" @click="placetype(item.id)" v-model="search_data.type" v-show="item.id!=1">{{item.name}}</el-button> -->
          </el-row>
        </div>
      </div>
      <div class="ivu-mt">
        <l-auth-button type="primary" auth="cabinet_template_add_btn" @click="add_visible = true"> 添加 </l-auth-button>
        <div class="l-simple-search-container">
        <el-input placeholder="请输入查找内容" v-model="search_data.name" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
        </el-input>
      </div>
      </div>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column fixed prop="index" label="序号" width="100"> </el-table-column>

      <!-- <el-table-column prop="is_public" label="是否为公共" min-width="80">
        <template slot-scope="{ row }">
           <el-tag type="success" disable-transitions v-if="row.is_public == 1">{{ IS_PUBLIC[row.is_public] }}</el-tag>
          <el-tag type="danger" disable-transitions v-else-if="row.is_public == 2">{{ IS_PUBLIC[row.is_public] }}</el-tag>
        </template>
      </el-table-column> -->


      <!-- <el-table-column prop="place_type_name" label="归属场所类型" min-width="80"></el-table-column> -->

      <el-table-column prop="code" label="模板编码" min-width="100">
      </el-table-column>
      
      <el-table-column prop="name" label="名称" min-width="80">
      </el-table-column>

      <el-table-column prop="abbreviation" label="缩写" min-width="80"> </el-table-column>
      
      <el-table-column prop="is_active" label="状态" min-width="80"> 
        <template slot-scope="{ row }">
          <el-tag :type="row.is_active == STATES.enabled ? 'success' : 'danger'" size="small" disable-transitions>{{ STATE_NAMES[row.is_active] }}</el-tag>
        </template>
      </el-table-column>
      
      <el-table-column prop="created_at" label="创建时间" width="180"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="350" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="cabinet_template_detail_btn" @click="showInfo(row.id,row.name)"><i class="el-icon-edit"></i>详情</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="primary" auth="cabinet_template_edit_btn" @click="showEdit(row.id)"><i class="el-icon-edit"></i>编辑</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="danger" auth="cabinet_template_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>

    <!--添加-->
    <l-dialog :visible.sync="add_visible" title="添加消防柜模板" width="1100px">
      <l-cabinet-template-edit @on-success="onAddSucess" :visible.sync="add_visible"></l-cabinet-template-edit>
    </l-dialog>

    <!--器材详情-->
    <l-dialog :visible.sync="info_visible" :title="cabinet_name" width="1500px">
      <l-material-edit @on-success="onEditSucess" :visible.sync="info_visible" :id="info_id"></l-material-edit>
    </l-dialog>

    <!--编辑-->
    <l-dialog :visible.sync="edit_visible" title="编辑消防柜模板" width="1100px">
      <l-cabinet-template-edit @on-success="onEditSucess" :visible.sync="edit_visible" :id="edit_id"></l-cabinet-template-edit>
    </l-dialog>
  </el-card>
</template>

<script>

import TemplateEdit from "./TemplateEdit.vue";
import MaterialEdit from "./MaterialEdit.vue";
// import TemplateMaterialEdit from "./TemplateMaterialEdit.vue";
import { STATES, STATE_NAMES } from "@/common/constants/resources";
import Info from "./Info.vue";
import {
  getName,IS_PUBLIC
} from './lavel.js';

import Vue from "vue";
export default {
  components: {
    [TemplateEdit.name]: TemplateEdit,
    [MaterialEdit.name]: MaterialEdit,
    [Info.name]: Info,

  },
  data() {
    return {
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,
      // place_type_list:JSON.parse(store.get("place_type_list")),
      export_loading: false,
      change_state_loading: [],

      add_visible: false, //是否显示添加
      edit_visible: false, //是否显示编辑
      info_visible: false,  //获取责任人
      edit_id: 0,
      info_id: 0,
      community_id: 0,
      place_type: '',
      cabinet_name: '',
      IS_PUBLIC:IS_PUBLIC,
      //搜索
      search_visible: false,
      search_data: {
        name: "",
        place_type: ''
      },
      rel_search_data: {},
      show_more_search: false,
      STATE_NAMES: STATE_NAMES,
      STATES: STATES,
    };
  },
  computed: {
    place_type_list() {
      return this.$store.state.list.place_type_list
    },

  },

  mounted() {
    this.getList();
  },

  methods: {
    lavel_name(value) {
      return getName(value)
    },
    //获取数据
    getList() {
      this.loading = true;
      this.rel_search_data = this.search_data;
      this.$_invoke("trainTemplate_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //通过类型筛选
    // placetype(id) {
    //   this.search_data.place_type = id;
    //   this.place_type = id;
    //   this.rel_search_data = this.search_data;
    //   this.getList();
    // },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //页码改变
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    //每页显示条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getList();
    },
    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSucess() {
      this.edit_visible = false;
      this.getList();
    },


    //显示责任人 和添加修改和删除 
    showInfo(id,name) {
      this.info_id = id;
      this.cabinet_name= name;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },


    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`trainTemplate_del`, { id }).then((ret) => {
              if (ret != true) {
                  this.$_msg.success("删除失败");
              } else {
                  this.$_msg.success("删除成功");
                  this.getList();
              }
          });
        })
        .catch(() => { });
    },
  },
};
</script>
